import { baseApi } from "./base.api";

export const subscribersApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    subscribe: build.mutation({
      query: (body) => ({ url: "/subscribers/subscribe", method: "POST", body }),
      invalidatesTags: ["Subscriber"],
    }),
    fetchSubscribers: build.query({
      query: (params) => ({ url: "/subscribers/fetch", method: "GET", params }),
      providesTags: ["Subscriber"],
    }),
    fetchSubscribersAll: build.query({
      query: () => ({ url: "/subscribers/fetch/all", method: "GET" }),
      providesTags: ["Subscriber"],
    }),
    deleteSubscriber: build.mutation({
      query: (id) => ({ url: `/subscribers/delete/${id}`, method: "DELETE" }),
      invalidatesTags: ["Subscriber"],
    }),
    bulkDeleteSubscribers: build.mutation({
      query: (body) => ({ url: "/subscribers/bulk-delete", method: "POST", body }),
      invalidatesTags: ["Subscriber"],
    }),
  }),
});

export const {
  useSubscribeMutation,
  useFetchSubscribersQuery,
  useFetchSubscribersAllQuery,
  useDeleteSubscriberMutation,
  useBulkDeleteSubscribersMutation,
} = subscribersApi;
